import { useEffect } from "react";
import MainLayout from "@/layouts/MainLayout";
import { logout, ValidateToken } from "@/utils/authentication";
import { Navigate } from "react-router-dom";

interface Props {
  roles: string[], //[UserRole.User, UserRole.Superuser, UserRole.Admin]
  // usertypes: string[], //[UserType.Developer, UserType.Employee, UserType.Financier]
}

/**
 * This function protects all routes that can only be accessed by Users that are logged in
 * @returns the requested page if the User is logged in. Login Page otherwise
 */
function ProtectedRoute({ roles }: Props) {
  const isValid = ValidateToken(roles);

  // Move logout side-effect to useEffect so it's not executed during render
  useEffect(() => {
    if (!isValid) {
      logout();
    }
  }, [isValid]);

  if (!isValid) {
    return <Navigate to="/login" replace />;
  } else {
    return <MainLayout />;
  }
}

export default ProtectedRoute;
